import React from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import Truncate from '../../common/Truncate';
import { useMonitoring } from '../../../monitoring';

import styles from './index.module.scss';

const T_PREFIX = 'freelancer_page.about';

/** @type {import('./index').AboutMe} */
export const AboutMe = ({ className, description, withClamp = true }) => {
    const { Providers, fireEvents } = useMonitoring();

    const onReadMoreBI = () => {
        fireEvents({
            [Providers.Mixpanel]: {
                type: 'clicked read more',
            },
        });
    };

    return (
        <div className={classnames(className, styles.aboutMe)}>
            <div className="m-b-8 text-semi-bold co-text-darkest">
                <I18n k={`${T_PREFIX}.title`} />
            </div>
            <div className={classnames(styles.description)}>
                {withClamp ? (
                    <Truncate lines={3} onReadMore={onReadMoreBI}>
                        {description}
                    </Truncate>
                ) : (
                    description
                )}
            </div>
        </div>
    );
};
